/**
 * Structured auth observability. No tokens or secrets in logs.
 * Used by authManager and AuthContext for refresh/session/state transitions.
 */

const isDev = typeof import.meta !== 'undefined' && import.meta?.env?.DEV === true;

export type AuthLogEvent =
  | 'refresh_attempt'
  | 'refresh_success'
  | 'refresh_failure'
  | 'session_invalidated'
  | 'logout'
  | 'auth_state_transition'
  | 'auth_401_received';

export interface AuthLogPayload {
  event: AuthLogEvent;
  reason?: string;
  state?: string;
  endpoint?: string;
  statusCode?: number;
}

function safeStringify(payload: AuthLogPayload): string {
  const parts = [`[Auth] ${payload.event}`];
  if (payload.reason) parts.push(`reason=${payload.reason}`);
  if (payload.state) parts.push(`state=${payload.state}`);
  if (payload.endpoint) parts.push(`endpoint=${payload.endpoint}`);
  if (payload.statusCode != null) parts.push(`status=${payload.statusCode}`);
  return parts.join(' ');
}

export function logAuthEvent(payload: AuthLogPayload): void {
  const msg = safeStringify(payload);
  if (payload.event === 'refresh_failure' || payload.event === 'session_invalidated') {
    console.warn(msg);
  } else if (isDev) {
    console.debug(msg);
  }
}
